import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({

    activeDialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: "600px"
    },
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: window.isIpadView ? '' : "600px",
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 15px 0px',
        "& hr": {
            overflow: 'auto',
            height: '1px',
            width: '90%',
            opacity: 0.3,
        }
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '8px 10px 0px 10px',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 30px'
    },

    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px'
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    footerCenter: {
        float: "center",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
    },
    logoArea: {
        width: '130px',
        padding: '10px 14px',
    },
    selectHeading: {
      "& h2": {
        margin: '0px auto 15px auto',
      }  
    },
    userContent: {
        border: '1px solid #D9D9D9',
        borderRadius: '19px',
        textAlign: 'center',
        padding: '15px 10px',
        minHeight: '250px',
        justifyContent: 'center',
        display: 'flex',
        flexFlow: 'column',
        textAlign: 'center',
        margin: '5px',
        cursor: 'pointer',
        "&:hover": {
            border: '1px solid #0686D8',
            boxShadow: '0px 0px 4px rgba(0, 73, 163, 0.3)',
        },
        "& h3": {
            fontSize: '20px',
        },
        "& h4": {
            fontSize: '17px',
            margin: 0,
        },
        "& .emailLink": {
            color: '#0686D8',
            wordWrap: 'break-word',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        }
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        color: '#B3B3B3',
        cursor: 'pointer',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    backBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#0049A3',
        borderRadius: '4px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        textTransform: 'capitalize',
        border: '1px solid #0049A3',
        cursor: 'pointer',
    },

    deleteBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#f50057',
        borderRadius: '4px',
        marginRight: '5px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    profileImg: {
        position: 'relative',
        width: 'fit-content',
        margin: 'auto',
    },
    EditICon: {
        width: '40px',
        right: '60px',
        bottom: '13px',
        cursor: 'pointer',
        padding: '9px',
        zIndex: 4,
        position: 'absolute',
        background: '#0049A3',
        borderRadius: '16px',
    },
    uploadImageLabel: {
        position: 'relative',
        width: 'fit-content',
        margin: 'auto',
        borderRadius: '8px',
        alignItems: 'center',
        cursor: 'pointer',
        display: 'block',
        "& img": {
            objectFit: 'cover',
        }
    },

    changeBtn: {
        fontSize: window.isMobileView ? window.isMobile425 ? '8px' : '10px' : '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    uploadButton: {
        border: '1px solid #cfcfcf',
        margin: '5px 0px',
        borderRadius: '5px',
        cursor: 'pointer',
    }
}));